import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PlenaLogo } from "@/components/brand/PlenaLogo";
import { ProgressBar } from "@/components/common";
import { useEvaluation } from "./EvaluatorApp";
import { JobDrawer } from "./EvaluatorHeader";

const STEPS = ["İlanı inceleyin", "Kategorileri önceliklendirin", "Adayları değerlendirin", "Adayları sıralayın", "Değerlendirmenizi tamamlayın"];

export default function LandingPage() {
  const { ctx, token } = useEvaluation();
  const nav = useNavigate();
  const [jobOpen, setJobOpen] = useState(false);
  const started = ctx.progress.evaluated > 0 || ctx.status === "IN_PROGRESS";
  return (
    <div className="min-h-screen">
      <header className="mx-auto flex max-w-3xl items-center justify-between px-6 pt-8">
        <PlenaLogo height={26} />
        <span className="eyebrow">Aday Değerlendirmesi</span>
      </header>
      <main className="fade-up mx-auto max-w-3xl px-6 pb-24 pt-20">
        {ctx.evaluator?.name && <p className="text-sm text-plena-text2">Merhaba {ctx.evaluator.name.split(" ")[0]},</p>}
        <h1 className="mt-3 font-heading text-4xl font-bold tracking-tight sm:text-5xl" data-testid="landing-job-title">{ctx.job.title}</h1>
        <p className="mt-4 text-lg text-plena-text2" data-testid="landing-candidate-count">Bu pozisyon için {ctx.progress.total} adayı değerlendireceksiniz.</p>

        <ol className="mt-14 space-y-5">
          {STEPS.map((s, i) => (
            <li key={s} className="flex items-baseline gap-5">
              <span className="font-heading text-sm font-semibold tabular-nums text-plena-muted">0{i + 1}</span>
              <span className="font-heading text-lg font-medium">{s}</span>
            </li>
          ))}
        </ol>

        <div className="mt-14 max-w-sm">
          <p className="mb-2 text-sm text-plena-text2" data-testid="landing-progress">{ctx.progress.evaluated} / {ctx.progress.total} aday değerlendirildi</p>
          <ProgressBar value={ctx.progress.evaluated} total={ctx.progress.total} />
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <Button data-testid="start-evaluation-button" onClick={() => nav(`/e/${token}/${ctx.category_ranking_complete ? "candidates" : "priorities"}`)} className="btn-press h-12 rounded-full px-7 text-base font-semibold">
            {started ? "Değerlendirmeye Devam Et" : "Değerlendirmeye Başla"} <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <Button variant="ghost" data-testid="landing-view-job-button" onClick={() => setJobOpen(true)} className="h-12 rounded-full px-5 text-base">İlanı İncele</Button>
        </div>
        <p className="mt-12 max-w-md text-xs leading-relaxed text-plena-muted">Değerlendirmeniz otomatik olarak kaydedilir; tarayıcıyı kapatıp aynı bağlantıyla daha sonra devam edebilirsiniz. Yanıtlarınız yalnızca değerlendirme ekibiyle paylaşılır.</p>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-plena-text2" data-testid="landing-reopen-note">Gönderdikten sonra bir puanı değiştirmeniz gerekirse yöneticinize yazın; kaydınız yeniden açılır, mevcut puanlarınız korunur ve yalnızca istediğiniz adayı düzenleyip tekrar gönderirsiniz.</p>
      </main>
      <JobDrawer open={jobOpen} onOpenChange={setJobOpen} />
    </div>
  );
}
